"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var react_virtualized_1 = require("react-virtualized");
require("react-virtualized/styles.css");
var MultiSelectHeader_1 = __importDefault(require("./MultiSelectHeader"));
var MultiSelectProgress_1 = __importDefault(require("./MultiSelectProgress"));
var ApplyButton_1 = __importDefault(require("./ApplyButton"));
var ROW_HEIGHT = 40;
var DEFAULT_LIST_WIDTH = 250;
var DEFAULT_LIST_HEIGHT = 300;
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    root: {
        minWidth: DEFAULT_LIST_WIDTH,
        height: DEFAULT_LIST_HEIGHT
    },
    list: {
        width: '100%',
        height: function (_a) {
            var showApplyButton = _a.showApplyButton;
            return "calc(100% - ".concat(theme.spacing(showApplyButton ? 12 : 6), "px)");
        },
        position: 'relative'
    }
}); });
var AutoSizer = react_virtualized_1.AutoSizer;
var List = react_virtualized_1.List;
var MultiSelectList = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var label = _a.label, search = _a.search, handleSearch = _a.handleSearch, rowCount = _a.rowCount, rowRenderer = _a.rowRenderer, isLoading = _a.isLoading, handlerAllChange = _a.handlerAllChange, showCheckbox = _a.showCheckbox, classes = _a.classes, placeholder = _a.placeholder, statusSelectedItems = _a.statusSelectedItems, showApplyButton = _a.showApplyButton, handlerApply = _a.handlerApply, formatMessage = _a.formatMessage, applyButtonProps = _a.applyButtonProps;
    var internalClasses = useStyles({ showApplyButton: showApplyButton });
    return (react_1.default.createElement("div", { 
        // @ts-ignore
        ref: ref, className: (0, classnames_1.default)(internalClasses.root, ((_b = classes === null || classes === void 0 ? void 0 : classes.menuHeader) === null || _b === void 0 ? void 0 : _b.root) || '') },
        react_1.default.createElement(MultiSelectHeader_1.default, { showCheckbox: showCheckbox, label: label, search: search, handleSearch: handleSearch, handlerAllChange: handlerAllChange, classes: classes, placeholder: placeholder, statusSelectedItems: statusSelectedItems }),
        react_1.default.createElement("div", { className: internalClasses.list },
            isLoading === 'load' && react_1.default.createElement(MultiSelectProgress_1.default, null),
            react_1.default.createElement(AutoSizer, null, function (_a) {
                var width = _a.width, h = _a.height;
                return (react_1.default.createElement(List, { height: h, rowCount: rowCount, rowHeight: ROW_HEIGHT, rowRenderer: rowRenderer, width: width }));
            })),
        showApplyButton && (react_1.default.createElement(ApplyButton_1.default, { applyButtonProps: applyButtonProps, formatMessage: formatMessage, handlerApply: handlerApply }))));
});
exports.default = (0, react_1.memo)(MultiSelectList);
